import { StyledWidget, StyledButton } from '@/components/styles';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Icon from '@/assets/icons';
import * as gtag from '@/lib/gtag';
import { useHost } from '@/contexts/HostContext'
import { getCanonicalUrl } from '@/lib/locales'
import { buildWhatsAppUrl } from '@/lib/attribution'

const WHATSAPP_HREF = 'https://wa.me/97143830500'

export default function ContactWidgetButton({ fixed = true }) {
  const router = useRouter();
  const host = useHost();
  const pageUrl = getCanonicalUrl(router?.asPath || '/', host);
  const [href, setHref] = useState(WHATSAPP_HREF);

  useEffect(() => {
    setHref(buildWhatsAppUrl(WHATSAPP_HREF, pageUrl));
  }, [pageUrl]);

  return (
    <StyledWidget static={!fixed}>
      <StyledWidget.Button
        green
        as="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          gtag.gtag_report_conversion('AW-18230806173/O4BNCKbCvMAcEJ2NkPVD');
        }}
      >
        <Icon name="whatsapp" fill="white" width={30} height={30} />
      </StyledWidget.Button>
    </StyledWidget>
  );
}
